exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".src-components-dashboard-widgets-separator-___styles__container___22lPy {\n  display: flex;\n  width: 100%;\n  height: 100%;\n}\n\n.src-components-dashboard-widgets-separator-___styles__container___22lPy > div {\n  flex: 1;\n}\n\n.src-components-dashboard-widgets-separator-___styles__container___22lPy > div:first-child {\n  border-right: 1px solid #D8D8D8;\n}", ""]);

// exports
exports.locals = {
	"container": "src-components-dashboard-widgets-separator-___styles__container___22lPy"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./~/resolve-url-loader!./~/sass-loader!./src/components/dashboard/widgets/separator/styles.scss
// module id = 2347
// module chunks = 0